<div class="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> Veranstaltungsscanner </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-stepper [linear]="true" #stepper id="stepper">
                        <mat-step [stepControl]="addFormEvent" [formGroup]="addFormEvent">
                            <ng-template matStepLabel>Aktion auswählen</ng-template>
                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Suchen...</mat-label>
                                        <input matInput formControlName="searchTerm" (change)="filterEvents()">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="example-container">
                                        <table mat-table [dataSource]="dataSource" matSort>
                                            <ng-container matColumnDef="menu">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Auswählen
                                                </th>
                                                <td mat-cell *matCellDef="let element;let i = index;">
                                                    <mat-checkbox [checked]="selectedEvent === i"
                                                        (change)="selectedEvent = i" (click)="setActiveEvent(element)">
                                                    </mat-checkbox>
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="user">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    Kunde
                                                </th>
                                                <td mat-cell *matCellDef="let element" class="mat-column w70"
                                                    style="padding-right: 25px;">
                                                    <span>
                                                        {{element.title}}
                                                    </span>
                                                </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                                            </tr>
                                        </table>
                                        <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine
                                            passenden
                                            Einträge
                                            gefunden...</span>
                                        <mat-paginator [length]="page.totalElements" class="paginator-centered"
                                            [pageSize]="page.size" [pageIndex]="page.number" (page)="loadPage($event)"
                                            [pageSizeOptions]="[4,8, 16, 24]" *ngIf="page">
                                        </mat-paginator>
                                    </div>
                                    <mat-error *ngIf="addFormEvent.get('event').hasError('required')">
                                        Aktion <strong>muss</strong> ausgewählt werden
                                    </mat-error>
                                    <br>
                                </div>
                            </div>
                            <div>
                                <button mat-raised-button color="primary" matStepperNext>Weiter</button>
                            </div>
                        </mat-step>

                        <mat-step label="Gutscheine angeben" [stepControl]="voucherForm" [formGroup]="voucherForm">
                            <div class="row">
                                <div class="col-sm-12">
                                    <mat-form-field class="full-width">
                                        <mat-label>Gutscheincode...</mat-label>
                                        <input matInput formControlName="code" (keyup.enter)="enterVoucherCode($event)">
                                        <mat-hint>Einen Gutscheincode eingeben und mit Enter bestätigen</mat-hint>
                                    </mat-form-field>
                                </div>
                            </div>

                            <mat-list role="list" class="VoucherCodesList">
                                <mat-list-item role="listitem" *ngFor="let item of enterdVoucherCodes">
                                    <h3 mat-line> {{item.val}}</h3>
                                    <button mat-icon-button (click)="delteVoucerKey(item)">
                                        <mat-icon class="mat-24">delete</mat-icon>
                                    </button>
                                </mat-list-item>
                            </mat-list>
                            <div class="row">
                                <div class="col-lg-12">
                                    <mat-checkbox formControlName="forceAttendance">
                                        <span [innerHtml]="'Automatische Verarbeitung'"></span>
                                    </mat-checkbox>
                                </div>
                            </div>
                            <br>
                            <div>
                                <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                                <button mat-raised-button color="accent" matStepperNext style="margin-left: 15px;" (click)="enterVoucherCodeViaBtn()">Einlösen</button>
                            </div>
                        </mat-step>

                        <!-- <mat-step>
                            <ng-template matStepLabel>Übersicht</ng-template>
                            <mat-list role="list" class="VoucherCodesList">
                                <mat-list-item role="listitem" *ngFor="let item of enterdVoucherCodes">
                                    {{item.val}} 
                                    <span  style="color: #d84315;">
                                         {{item?.error}}
                                    </span>
                                </mat-list-item>
                            </mat-list>
                            <br>
                            <div>
                                <button mat-raised-button color="primary" matStepperPrevious>Zurück</button>
                                <button mat-raised-button color="primary" matStepperNext style="margin-left: 15px;"
                                    (click)="quickAttendance()">Gutscheine verarbeiten</button>
                            </div>
                        </mat-step> -->

                    </mat-stepper>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>